import Vue from "vue";
import { errorServeiceHandler, makeQueryStringDync } from "../helper";

const actions = {
  actGetChannelList: (context, payload) => {
    return new Promise((resolve, reject) => {
      if (!payload) {
        reject({ error: "payload not found" });
      }
      let data = makeQueryStringDync(payload);
      fetch(context.getters.baseUrl + "/subscriber/v1/plan/channel" + data, {
        method: "GET"
      })
        .then(errorServeiceHandler)
        .then(response => {
          return response.json();
        })
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/planDetailImg.js